'use strict';

const {
  bindTargetNavigation,
} = require('../../desktop_2016/frontend/bind_target_navigation');

const heightOffsetCalculator = beforeScroll => {
  return ({ resolve }) => {
    const stickyFooter = document.querySelector('#sticky-footer.hybrid-footer');
    const stickyDealHighlights = document.querySelector(
      '.deal-highlights.sticky-ums'
    );
    const stickyFooterHeight =
      !stickyFooter || stickyFooter.classList.contains('sticky')
        ? 0
        : stickyFooter.offsetHeight;
    const stickyDealHighlightsHeight = stickyDealHighlights
      ? stickyDealHighlights.offsetHeight
      : 0;

    if (beforeScroll && 'function' === typeof beforeScroll) {
      beforeScroll({ resolve });
    }
    resolve(stickyFooterHeight + stickyDealHighlightsHeight);
  };
};

const touchBindTargetNavigation = (anchorElement, beforeScroll) => {
  bindTargetNavigation(anchorElement, heightOffsetCalculator(beforeScroll));
};

module.exports = touchBindTargetNavigation;
